import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

import delegateEvent from '../utilities/delegateEvent.js';

export default function SwiperSlider() {
  const instances = [];
  return {
    instances: () => instances,
    init: () => {
      const elements = document.querySelectorAll('[data-w-swiper-container]');
      elements.forEach((element) => {
        const instance = {};
        instance.container = element;
        instance.element = element.querySelector('[data-w-swiper]');
        const type = instance.element.getAttribute('data-w-swiper');

        const config = {
          modules: [],
          slidesPerView: 'auto',
          speed: 700,
          // on: {},
          // navigation: {
          //   disabledClass: 'w-is-disabled',
          //   prevEl: instance.container.querySelector(
          //     '[data-w-swiper-goto="prev"]'
          //   ),
          //   nextEl: instance.container.querySelector(
          //     '[data-w-swiper-goto="next"]'
          //   ),
          // },
        };

        if (type === 'items') {
          config.slidesPerView = 3.5;
          config.spaceBetween = 20;
          // config.modules.push(Navigation);
          // config.navigation = {
          //   nextEl: '.swiper-button-next',
          //   prevEl: '.swiper-button-prev',
          // };
          config.modules.push(Pagination);
          config.pagination = {
            type: 'bullets',
            el: instance.element.querySelector('.swiper-pagination'),
          };
          config.breakpoints = {
            0: {
              spaceBetween: 20,
              slidesPerView: 1.5,
            },
            640: {
              slidesPerView: 2.5,
            },
            768: {
              spaceBetween: 24,
            },
            1024: {
              slidesPerView: 3.5,
            },
            1440: {
              slidesPerView: 4.5,
            },
          };
        }

        instance.swiper = new Swiper(instance.element, config);
        instance.config = config;

        instances.push(instance);
      });

      // delegateEvent(
      //   document,
      //   'click',
      //   '[data-w-swiper-goto]',
      //   (event, element) => {
      //     const container = element.closest('[data-w-swiper-container]');
      //     const swiper = container.querySelector('[data-w-swiper]').swiper;
      //     const target = element.getAttribute('data-w-swiper-goto');
      //     if (target === 'prev') {
      //       swiper.slideTo(swiper.realIndex - 0.5, 700);
      //     } else if (target === 'next') {
      //       swiper.slideTo(swiper.realIndex + 0.5, 700);
      //     } else {
      //       swiper.slideTo(parseInt(target), 700);
      //     }
      //   }
      // );
    },
  };
}
